<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-6">
                <label for="batch_id" class="col-form-label col-form-label-sm">Select Batch <span style="color: red">*</span></label>
                <select v-model="search_data.batch_id" v-validate="'required'" id="batch_id" name="batch_id" class="form-control form-control-sm">
                  <option :value="''" selected>Select Batch</option>
                  <option v-for="(batch, index) in batches" :key="index" :value="batch.id">
                    {{ batch.trade.desc + " | " + "Batch No: " + batch.batch_no}}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please Select Batch
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-6 custom-search">
                <button class="btn btn-success btn-sm custom-search-button" @click.prevent="search">
                  Search
                </button>
              </div>
            </div>
          </form>
        </b-card>

        <b-card>
          <div class="row mb-2">
            <div class="col-sm-12">
              <div v-if="trainee_grades.length > 0">
                <span class="badge badge-success mr-2">Total Search Data Found: {{ trainee_grades.length }}</span>

                <!-- download button -->
                <download-excel
                        class = "btn btn-light float-right"
                        :data = "trainee_grades"
                        :fields = "trainee_grade_fields"
                        :meta="json_meta"
                        worksheet = "Trainee Grades"
                        name = "trainee-grades.xls">
                        <span v-if="loading" class="spinner-border spinner-border-sm text-muted"></span>
                  Download Excel
                </download-excel>
              </div>
            </div>
          </div>
          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>SL</th>
                <th>Exam</th>
                <th>Exam Date</th>
                <th>Mark</th>
                <th>Grade</th>
                <th>Remark</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(trainee_grade, index) in trainee_grades" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ trainee_grade.trainee_exam.title }}</td>
                <td>{{ trainee_grade.trainee_exam.date }}</td>
                <td>{{ trainee_grade.marks }}</td>
                <td>{{ trainee_grade.grade }}</td>
                <td>{{ trainee_grade.remarks }}</td>
              </tr>
              </tbody>
            </table>
            <h5 v-if="trainee_grades.length === 0" class="text-center text-secondary">No Data Found</h5>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";


export default {
  page: {
    title: "List Trainee Grade",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, PageHeader },
  data() {
    return {
      title: "Search Trainee Grade",
      items: [
        {
          text: "Trainee Grade",
          href: "/"
        },
        {
          text: "Dashboard",
          active: true
        }
      ],
      search_data: {
        batch_id: ''
      },
      batches: {},
      loading : false,
      trainee_grades: [],
      trainee_grade_fields : {
        "Exam" : "trainee_exam.title",
        "Exam Date" : "trainee_exam.date",
        "Mark" : "marks",
        "Grade" : "grade"
      }
    };
  },


  mounted() {
    this.getBatches();
  },
  methods: {
    search() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http
            .post("api/batch/grade/search", this.search_data)
            .then(response => {
              if (!response.error) {
                this.trainee_grades = response.data.trainee_grades;
                console.log(this.trainee_grades)
              }
            });
        }
      });
    },
    getBatches() {
      http.get("api/batch/trainee/getBatch").then(response => {
        if (!response.error) {
          this.batches = response.data.batches;
        }
      });
    },
  },
};
</script>

